<template>
    <el-drawer v-bind="mergedProps" :visible.sync="drawerVisible" @close="handleClose" v-on="$listeners">
        <!-- 标题插槽 -->
        <template v-if="$slots.title" #title>
            <div class="flex">
                <slot name="title"></slot>
            </div>
        </template>
        <!-- 默认内容插槽 -->
        <slot></slot>
    </el-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        // 可覆盖默认配置
        config: {
            type: Object,
            default: () => ({
                direction: 'rtl',
                size: '40%',
                destroyOnClose: true
            })
        }
    },
    computed: {
        drawerVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        },
        mergedProps() {
            return { ...this.config, ...this.$attrs }
        }
    },
    methods: {
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep .el-drawer__header {
    margin-bottom: 0 !important;
    color: #333;
    font-weight: bold;
    font-size: 14px;
}

::v-deep .el-drawer__body {
    font-size: 12px;
    padding: 16px 24px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
}
</style>